import { Icon } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DonateToCharityModal } from '@hero/components/modals';
import { DetailItem } from '@hero/molecules';

import * as S from './style';

function CharityVerticalListHeader({
  isDetailItemEditable,
  collectionSize,
  setShowCharitiesModal
}) {
  const { t } = useTranslation();
  const [showCharityInfoModal, setShowCharityInfoModal] = useState(false);

  const openProductModal = () => {
    setShowCharitiesModal(true);
  };

  return (
    <S.VerticalListHeader>
      <DetailItem
        editable={isDetailItemEditable}
        editButtonText={t('edit')}
        onClickEditButton={openProductModal}
        title={`${t('charities')}:`}
        titleIconOnClick={() => setShowCharityInfoModal(true)}
        titleIcon={<Icon name="info" />}
      >
        {collectionSize || 0}
      </DetailItem>
      <DonateToCharityModal
        isOpen={showCharityInfoModal}
        setIsOpen={setShowCharityInfoModal}
        primaryButtonProps={{
          onClick: openProductModal,
          children: t('seeAvailableCharities')
        }}
        secondaryButtonProps={{
          children: t('cancel')
        }}
      />
    </S.VerticalListHeader>
  );
}

export { CharityVerticalListHeader };
